module.exports = __webpack_public_path__ + "static/media/nodejs_logo.33b6e33d.png";